<div class="wrapper flex flex-col gap-[20px]">
  <div class="heading text-type-1">
    Create daily diary
  </div>
  <form class="flex flex-col gap-[calc(40px-1.25em)]">
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [enableClearSelection]="false"
      [error]="errorMessages['project']"
      [options]="projectsList"
      [parentFormGroup]="form"
      controlName="project"
      label="Project"
      placeholder="Select a project"
    />
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [enableClearSelection]="false"
      [enableSearch]="true"
      [error]="errorMessages['site']"
      [options]="sitesList"
      [parentFormGroup]="form"
      controlName="site"
      label="Site"
      placeholder="Select a site"
    />
    <div>
      <app-date-picker
        (checkForErrors)="checkForErrors($event)"
        [class.reduce-padding]="existingDiaryId"
        [parentFormGroup]="form"
        class="datepicker"
        controlName="diary_date"
        label="Date"
        placeholder="Select a date"
      />
      <!-- Same warning the report shows: the api returns the existing record
           for this site + date + author instead of making a second one. -->
      @if (existingDiaryId) {
        <div class="diary-exists flex">
          <mat-icon class="error-icon" svgIcon="error" />
          <div class="error-message text-type-14">
            A diary is created by you for this date. Select a different date or
            <span (click)="goToDiary()" class="clickable">go to diary</span>
          </div>
        </div>
      }
    </div>
  </form>
  <div class="actions mt-[calc(100px-1.25em)]">
    <app-primary-button
      (handleClick)="onSubmit()"
      [isDisabled]="!form.valid || saving || !!existingDiaryId"
      data-testid="create-diary-btn"
    >
      {{ saving ? 'Creating…' : 'Create' }}
    </app-primary-button>
  </div>
</div>
